import { render, staticRenderFns } from "./PageProductForm.vue?vue&type=template&id=34caa7a4&"
import script from "./PageProductForm.vue?vue&type=script&lang=js&"
export * from "./PageProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports